import { connect } from 'react-redux';
import withRouter from 'shared/helper/with-router';
import { loadEligiblePayments, createPaddleFapiao } from 'rubriq/actions';
import InvoiceFapiaoRequest from 'researcher/invoice/components/InvoiceFapiaoRequest';
import { loadPaddleFapiaos } from 'researcher/fapiao/actions';
import { getPaddleInvoice, getPaddlePayment } from '../reducer';
var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    invoice: getPaddleInvoice(state, ownProps),
    payment: getPaddlePayment(state, ownProps),
    redirectUrl: '/rubriq/invoices',
    backLinkText: 'Return to My Invoices'
  };
};
var mapDispatchToProps = {
  loadInvoices: loadEligiblePayments,
  createFapiao: createPaddleFapiao,
  loadFapiaos: loadPaddleFapiaos
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InvoiceFapiaoRequest));